import { Enrolment } from '@/models/enrolment';
import { CsvExport } from './csv-export';

export class ClientCsvExport extends CsvExport {
	public constructor() {
		super('All the enrolments currently displayed in the table');
	}

	protected findExportableEnrolments(enrolments: Enrolment[]): Enrolment[] {
		return enrolments;
	}

	protected determineEmptyExportFileName(): string {
		return 'Empty client review export';
	}

	protected determineExportFileNameFromEnrolment(enrolment: Enrolment): string {
		return `Enrolments export for ${enrolment.organisationName}`;
	}

	protected createHeaderCells(): string[] {
		return [
			'Review status',
			'Student name',
			'Student email address',
			'Degree level',
			'Nationality',
			'Intake year',
			'Intake month',
			'Source',
			'Success fee category',
			'Tuition fee value',
			'Tuition fee currency',
			'Notes'
		];
	}

	protected createEnrolmentLineCells(enrolment: Enrolment): string[] {
		return [
			this.determineReviewStatus(enrolment),
			enrolment.studentName,
			enrolment.studentEmail ? enrolment.studentEmail : '',
			enrolment.programmeLevel ? enrolment.programmeLevel.name : '',
			enrolment.studentNationality ? enrolment.studentNationality.name : '',
			enrolment.intakeYear ? enrolment.intakeYear.toString() : '',
			enrolment.intakeMonth ? enrolment.intakeMonth.name : '',
			enrolment.clientSourceName,
			enrolment.successFeeText,
			enrolment.tuitionFee ? enrolment.tuitionFee.toString() : '',
			enrolment.tuitionFeeCurrency ? enrolment.tuitionFeeCurrency.isoCode : '',
			enrolment.confirmationNotes
		];
	}

	private determineReviewStatus(enrolment: Enrolment): string {
		if (enrolment.isAwaitingReview() || enrolment.isReadyToShareWithClient()) {
			return '';
		}

		return enrolment.status.clientFacingName;
	}
}
